import type { ChatCopilotPaneProps } from './components/ChatCopilotPane';
import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';
import type { ChatCopilotPaneHeaderProps } from './components/ChatCopilotPaneHeader';

const lazyModules: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OwaCopilotChat" */ './lazyIndex'),
    { name: 'OwaCopilotChat' }
);

// Export components
export const ChatCopilotPane: LazyComponent<ChatCopilotPaneProps, unknown, void> =
    createLazyComponent(lazyModules, m => m.ChatCopilotPane);

export const ChatCopilotPaneHeader: LazyComponent<ChatCopilotPaneHeaderProps, unknown, void> =
    createLazyComponent(lazyModules, m => m.ChatCopilotPaneHeader);
